import React from 'react'

function InterviewScheduling() {
    return (
        <div>
            InterviewScheduling page
        </div>
    )
}

export default InterviewScheduling
